import { Group, Pagination } from '@mantine/core'

// #1080 案件一覧のページネーション。SPAではなくRails側で全ページ再取得する構成のため、
// ページ番号クリックではフェッチせず、そのページのURLへ遷移させる。
// pageParam: 1画面に複数の一覧がある場合にページ番号のクエリ名を分けるためのもの。省略時は 'page'。
export default function AppPagination({ currentPage, totalPages, baseHref, pageParam = 'page' }) {
  if (totalPages <= 1) return null

  const hrefForPage = (page) => {
    const url = new URL(baseHref, window.location.origin)
    url.searchParams.set(pageParam, page)
    return `${url.pathname}${url.search}`
  }

  return (
    <Group justify="center" my="xl">
      <Pagination
        total={totalPages}
        value={currentPage}
        onChange={(page) => { window.location.href = hrefForPage(page) }}
        withEdges
      />
    </Group>
  )
}
